<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <!-- <div class="topTool">
      <van-dropdown-menu>
        <van-dropdown-item v-model="search.date" :options="dateList" />
        <van-dropdown-item v-model="search.type" :options="typeList" />
      </van-dropdown-menu>
      <div class="moneyTj">本月支出 CNY100.00 收入 CNY100.00 佣金 CNY100.00</div>
    </div>
    <div class="topEmptyRect" />-->
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in list" :key="item.cash.moneyCashId" class="moneyRect" @click="onSelectItem">
        <div class="icon" :style="'background-color: '+GetColorMain()">
          <span v-if="item.account.cashType==='ALIPAY_TRANSFER'">支付宝</span>
          <span v-if="item.account.cashType==='WECHAT_TRANSFER'">微信</span>
          <span v-if="item.account.cashType==='OFFLINE'">线下支付</span>
          <span v-if="item.account.cashType==='BANK'">{{ item.account.bankName }}</span>

          <div v-if="item.account.cashType==='OFFLINE'">{{ item.account.cashName }}</div>
          <div v-if="item.account.cashType!=='OFFLINE'">{{ item.account.cashAccount }}</div>
        </div>
        <div class="title">
          <van-tag v-if="item.manageName" :color="GetColorMain()" type="primary">{{ item.manageName }}</van-tag>
          <span v-if="item.cash.state==='CREATE'">
            正在处理中
          </span>
          <span v-if="item.cash.state==='SUCCESS'">
            到账{{ item.cash.cashCurrency }} {{ ShowMoney(item.cash.cashPrice) }}
          </span>
          <span v-if="item.cash.state==='WAIT'">
            挂起:{{ item.cash.verifyAbout }}
          </span>
          <span v-if="item.cash.state==='ERROR'">
            失败:{{ item.cash.verifyAbout }}
          </span>
        </div>
        <div class="date">
          <span v-if="!item.cash.finishTime">申请：{{ formatDate(item.cash.createTime,"yyyy/MM/dd hh:mm",true) }}</span>
          <span v-if="item.cash.finishTime">完成：{{ formatDate(item.cash.finishTime,"yyyy/MM/dd hh:mm",true) }}</span>
        </div>
        <div class="price">
          <span>{{ GetEnumText("Em_MoneyCashState",item.cash.state) }}</span>
          <div>{{ item.cash.currencyBase }} {{ ShowMoney(item.cash.priceBase) }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, DropdownMenu, DropdownItem, List, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: '',
      title: '提现列表',
      backurl: '/pro/index',
      //   dateList: [
      //     { text: '2019年12月', value: '2019-12' },
      //     { text: '2019年11月', value: '2019-11' },
      //     { text: '2019年10月', value: '2019-10' }
      //   ],
      //   typeList: [
      //     { text: '全部', value: '' },
      //     { text: '佣金收入', value: '' },
      //     { text: '佣金支出', value: '' }
      //   ],
      search: {
        limit: 30,
        page: 1
        // date: '2019-12',
        // type: ''
      },
      list: [],
      loading: true,
      finished: false

    }
  },

  created() {
    this.titleTop = GetSysTitle()
    this.onLoad()
  },
  methods: {
    ShowMoney,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    GetEnumText,
    formatDate,
    onLoad() {
      this.loading = true
      request({
        url: '/pro/getMoneyCashList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onSelectItem(item) {

    }
  }
}
</script>
<style scoped>
.topTool{
    position: fixed;
    top: 3em;
    left: 0;
    right: 0;
    z-index: 10;
}
.topEmptyRect{
    height: 5em;
}
.moneyTj{
    background-color: #fff;
    border-bottom: 1px solid #cacaca;
    padding: 0.3em 0.5em;
    font-size: 0.8em;
    color: #999;
}
.moneyRect{
    position: relative;
    height: 4.8em;
}
.moneyRect .icon{
    position: absolute;
    width: 5em;
    height: 3.2em;
    top: 0.6em;
    left: 0.5em;
    background-color: #999;
    border-radius: 0.2em;
    text-align: center;
    line-height: 1.6em;
    color: #fff;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.moneyRect .icon span{
    font-size: 0.7em;
}
.moneyRect .icon div{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 0.5em;
}
.moneyRect .title{
    position: absolute;
    left: 6em;
    top:1em;
    right: 7em;

    line-height: 1.5em;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}
.moneyRect .title span{
  font-size: 0.6em;
}
.moneyRect .date{
    position: absolute;
    color: #999;
    left: 7em;
    top:2.6em;
    bottom: 0;
    right: 7em;
    font-size: 0.9em;
    line-height: 1.8em;
    border-bottom: 1px solid #cacaca;
}
.moneyRect .date span{
    font-size: 0.9em;
}

.moneyRect .price{
  position: absolute;
  right: 0.5em;
  top:0.7em;
  bottom: 0;
  width: 6em;
  text-align: right;
  border-bottom: 1px solid #cacaca;

}
.moneyRect .price span{
  font-size: 0.9em;
  font-weight: 700;
}
.moneyRect .price div{
  font-size: 0.8em;
  margin-top: 0.5em;
}
</style>
